import m from 'mithril'
import type { FeedEvent } from '../../shared/types.ts'
import { Stars, timeAgo } from '../ui.ts'

/** Links may point at things that no longer exist; the log records what happened. */
export const EventCard: m.Component<{ event: FeedEvent; hideAuthor?: boolean }> = {
  view: ({ attrs }) => {
    const { event } = attrs

    const place = event.restaurantRef
      ? m(
          m.route.Link,
          { href: `/r/${event.restaurantRef}`, class: 'place-name' },
          event.restaurantLabel,
        )
      : m('span.place-name', event.restaurantLabel)

    const list = event.listRef
      ? m(m.route.Link, { href: `/l/${event.listRef}`, class: 'list-chip' }, event.listName)
      : m('span.list-chip', event.listName)

    return m('article.card.review', [
      m('header.review-head', [
        attrs.hideAuthor
          ? null
          : m(
              m.route.Link,
              { href: `/u/${event.author.username}`, class: 'review-author' },
              event.author.displayName,
            ),
        m('time.muted', { datetime: event.at }, timeAgo(event.at)),
      ]),
      event.kind === 'review'
        ? m('p.saved-line', ['Reviewed ', place])
        : m('p.saved-line', ['Saved ', place, ' to ', list]),
      event.kind === 'review' && event.rating
        ? m('div.review-meta', m(Stars, { value: event.rating }))
        : null,
    ])
  },
}
